export default "__VITE_ASSET__R$0p5WHD__"